export default "__VITE_ASSET__TA6fOlS8__"